module.exports = {
  BOOKING_CREATE: 'BookingCreate',
  BOOKING_OVERVIEW: 'BookingOverview',
  SUPPLIER_PROPERTY_OVERVIEW: 'SupplierPropertyOverview',
  SUPPLIER_PROPERTY_ROOMS: 'SupplierPropertyRooms',
  SUPPLIER_PROPERTY_ADD_ROOMS: 'SupplierPropertyAddRooms',
  SUPPLIER_PROPERTY_CONNECTION: 'SupplierPropertyConnection',
  SUPPLIER_PROPERTY_RATE_MARKUP_LOGS: 'SupplierPropertyRateMarkupLogs',
  CHARGESHEETS: 'Chargesheets',
  CHARGESHEET: 'Chargesheet',
  CreateChargesheets: 'CreateChargesheets',
  CreateChargesheet: 'CreateChargesheet',
  Margins: 'margins',
  RATE_CARDS_SELECTED: 'RateCardsSelected',
  TICKETS: 'Tickets'
};
